import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CountUp from "react-countup";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import RFQModal from "../components/RFQModal";
import ReactPlayer from "react-player";

import {
  LuHeadset,
  LuMessagesSquare,
  LuScale,
  LuBadgeDollarSign,
  LuBot,
} from "react-icons/lu";

import Blogs from "../components/Blogs";
import OurPartners from "../components/OurPartners";


import hero1 from "../assets/img/testSlide1.png";
import hero2 from "../assets/img/testSlide3.jpg";
import hero3 from "../assets/img/testSlide4.jpg";
import hero4 from "../assets/img/testSlide2.jpeg";
import ind1 from "../assets/img/ind1.png";
import ind2 from "../assets/img/ind2.png";
import ind3 from "../assets/img/ind3.png";
import ind4 from "../assets/img/ind4.png";
import ind5 from "../assets/img/ind5.png";
import ind6 from "../assets/img/ind6.png";
import ind7 from "../assets/img/ind7.png";


const Home = () => {
  const [show, setShow] = useState(false);
  const [slide, setSlide] = useState(0);
  const [animateStats, setAnimateStats] = useState(false);

  const heroSlides = [
    {
      image: hero1,
      title: "4x Outbound Productivity for Our Client",
      text: "With Outcess's enhanced predictive dialling solution and AI-powered quality assurance, our client achieved four times its previous outbound productivity—expanding its capacity to engage prospects and execute telesales campaigns.",
    },
    {
      image: hero2,
      title: "Every Call Audited with AI",
      text: "Our in-house AI CQA audits every telesales call to identify quality gaps and agent development needs, giving supervisors a comprehensive view of call quality across the operation.",
    },
    {
      image: hero3,
      title: "Specific Feedback. Targeted Coaching.",
      text: "AI-generated quality scores after each successful call highlight where agents need to improve. Supervisors use these insights to tailor coaching and training to actual performance gaps.",
    },
      {
        image: hero4,
        title: "More Than Double the Loan Conversion Rate",
        text: "Our telesales operation recorded a 104% relative increase in loan conversion, with a greater share of successful calls resulting in disbursed loans.",
      },
  ];

  const totalSlides = 4;

  useEffect(() => {
    const interval = setInterval(() => {
      setSlide((prev) => (prev + 1) % totalSlides);
    }, 8000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimateStats(true);
        }
      },
      { threshold: 0.3 },
    );

    const stats = document.querySelector(".home-stats");

    if (stats) observer.observe(stats);

    return () => observer.disconnect();
  }, []);
  const services = [
    {
      title: "Business Process Outsourcing",
      description: "Skilled teams and dependable processes that handle customer operations and back-office work at scale.",
      link: "/business-process-outsourcing",
      icon: <LuHeadset />,
    },
    {
      title: "AI Driven Customer Engagement",
      description: "Acquire, retain, and grow a full-lifecycle contact center and CRM practice built for Nigeria and West Africa.",
      link: "/customer-engagement-solutions",
      icon: <LuMessagesSquare />,
    },
    {
      title: "AI Governance Lifecycle",
      description: "Use customer insight and timely engagement to improve acquisition, retention, and long-term value.",
      link: "/ai-governance-lifecycle",
      icon: <LuScale />,
    },
    {
      title: "AI Debt Recovery",
      description: "Prioritize accounts, personalize outreach, and support respectful, efficient debt recovery with AI.",
      link: "/ai-debt-recovery",
      icon: <LuBadgeDollarSign />,
    },
    {
      title: "Agentic AI",
      description: "AI that resolves inbound, runs outbound, and works across every channel with a human always one step away.",
      link: "/agentic-ai",
      icon: <LuBot />,
    },
  ];

  const industries = [
    {
      title: "Banking & Financial Services",
      image: ind1,
      description:
        "Support financial institutions with AI-powered customer engagement, contact center solutions, debt recovery.",
    },
    {
      title: "Telecommunications",
      image: ind2,
      description:
        "Support telecom providers to deliver seamless customer support, collections, technical helpdesk services, and omnichannel communication.",
    },
    {
      title: "Retail & E-commerce",
      image: ind3,
      description:
        "Enhance every stage of the customer journey with omnichannel support, AI-powered customer engagement that increase sales.",
    },
    {
      title: "Logistics",
      image: ind4,
      description:
        "Optimize customer communication, dispatch coordination, and back-office operations through intelligent customer service.",
    },
    {
      title: "Healthcare",
      image: ind5,
      description:
        "Improve patient engagement, appointment management, customer support, billing assistance, and administrative processes.",
    },
    {
      title: "Real Estate",
      image: ind6,
      description:
        "Helps real estate agencies, and property management firms streamline processes and build lasting relationships with clients.",
    },
    {
      title: "Government",
      image: ind7,
      description:
        "Supporting public sector transformation with secure, efficient, and citizen-centric solutions.",
    },
  ];

  return (
    <div id="home-new">
      <Navbar />

      {/* HERO */}

      <section className="home-hero">
        <div className="container hero-section">
          {heroSlides.map((item, index) => (
            <div
              key={index}
              className={`hero-slide ${slide === index ? "active" : ""}`}
              style={{
                backgroundImage: `url(${item.image})`,
              }}
            >
              <div className="hero-overlay">
                <div className="hero-content">
                  <h1>{item.title}</h1>
                  <p >{item.text}</p>

                  <button className="ccsnl-btn" onClick={() => setShow(true)}>
                    Book a Demo
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* STATS */}

      <section className="home-stats">
        <div className="stat-item">
          <h2>
            {animateStats && <CountUp end={30.5} duration={3} decimals={1} />}
            M+
          </h2>

          <p>CUSTOMER INTERACTIONS YEARLY</p>
        </div>

        <div className="stat-item">
          <h2>{animateStats && <CountUp end={3000} duration={3} />}+</h2>

          <p>CRM SEATS DEPLOYED</p>
        </div>

        <div className="stat-item">
          <h2>{animateStats && <CountUp end={201} duration={3} />}</h2>

          <p>SKILLED EXPERTS</p>
        </div>

        <div className="stat-item">
          <h2>{animateStats && <CountUp end={4000} duration={3} />}+</h2>

          <p>CONTACT CENTER SEATS</p>
        </div>
      </section>

      {/* COMPANY */}

      <section className="company-section">
        <div className="container">
          <div className="company-content">
            <div className="company-text">
              <span className="section-tag">OUR COMPANY</span>

              <h2>Who are we?</h2>

              <p>
                With over 20 years of industry experience, Outcess is a trusted
                technology and business solutions partner helping organizations
                enhance customer engagement, streamline operations, and improve
                productivity.
              </p>

              <p>
                We combine business process outsourcing, cloud technologies, and
                digital innovation to deliver solutions that drive efficiency,
                performance, and sustainable growth.
              </p>

              <Link to="/about">
                <button className="ccsnl-btn">Find Out More</button>
              </Link>
            </div>

            <div className="company-video">
              <ReactPlayer
                url={"https://youtu.be/Ywrd5bxr4LA?si=2nASb12aUqdQ9ut6"}
                width="100%"
                height="100%"
                controls
                playing={false}
                light
              />
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section className="home-services">
        <div className="container services-layout">
          <div className="services-content">
            <span className="section-tag">SERVICES WE OFFER</span>

            <h2>
              Comprehensive Solutions
              <br />
              for Digital Transformation
            </h2>

            <p>
              Our integrated solutions work seamlessly together, providing a
              unified partnership instead of disconnected services.
            </p>
          </div>

          <div className="service-grid">
            {services.map((service, index) => (
              <div
                className="home-service-card"
                key={index}
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="service-icon">{service.icon}</div>

                <h4>{service.title}</h4>

                <p>{service.description}</p>

                <Link to={service.link}>Learn More →</Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* INDUSTRIES */}
      <section className="industries-section">
        <div className="container">
          <div className="section-heading center">
            <span className="section-tag">
              INDUSTRIES THAT TRUST OUR SERVICES
            </span>

            <p>
              Trusted by organizations across industries to deliver innovative
              solutions that improve efficiency, customer experience, and
              business performance.
            </p>
          </div>

          <div className="industries-grid">
            {industries.map((industry, index) => (
              <div
                key={index}
                className="industry-card"
                data-aos="zoom-in"
                data-aos-delay={index * 100}
              >
                <img src={industry.image} alt={industry.title} />

                <div className="industry-content">
                  <h4>{industry.title}</h4>
                  <p>{industry.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ARTICLES */}
      <section className="home-articles">
        <div className="container">
          <div className="section-heading center">
            <span className="section-tag">Insights & Articles</span>

            <p>
              Stay informed with expert insights, industry trends, and practical
              strategies on customer experience, AI, business process
              outsourcing, digital transformation, and emerging technologies.
            </p>
          </div>

          <Blogs />
        </div>
      </section>

      {/* PARTNERS */}
      <section className="home-partners">
        <span className="section-tag">OUR TRUSTED PARTNERS</span>

        <OurPartners />
      </section>

      {/* CTA */}
      <section className="home-cta">
        <div className="container">
          <h2>Transform the Way You Engage Customers and Grow Your Business</h2>

          <p>
            Discover how Outcess combines AI, technology and operational
            expertise to improve customer experience.
          </p>

          <button className="ccsnl-btn" onClick={() => setShow(true)}>
            Book a Demo
          </button>
        </div>
      </section>
      {/* </main> */}

      <RFQModal show={show} setShow={setShow} />

      <Footer />
    </div>
  );
};

export default Home;
